export default __webpack_public_path__ + "static/media/pattern-1.167d0b89.jpg";